import React from 'react'
import PropTypes from 'prop-types'

import Vintage1 from './vintage-1.svg'
import Vintage2 from './vintage-2.svg'

const VintageBox = ({ children, vintageOne, vintageTwo, right, left, className }) => {
    // Determine which image to use
    const imageSrc = vintageOne ? Vintage1 : vintageTwo ? Vintage2 : null
    const imagePosition = right ? 'right-[-45px] left-auto' : left ? 'left-[-45px] right-auto' : ''

    const additionalClasses = className ? ` ${className}` : ''

    return (
        <div className={`relative inline-block${additionalClasses}`}>
            {children}
            {imageSrc && (
                <div
                    className={`absolute bottom-[-30px] ${imagePosition} block lg:hidden`}
                    style={{ content: `url(${imageSrc})` }}
                ></div>
            )}
            <style>
                {`
          @media (max-width: 450px) and (min-width: 402px) {
            .vintage-box:before {
              right: -10px;
              content: url(${imageSrc});
            }
          }

          @media (max-width: 402px) {
            .vintage-box:before {
              content: '';
            }
          }
        `}
            </style>
        </div>
    )
}

VintageBox.propTypes = {
    children: PropTypes.any.isRequired,
    vintageOne: PropTypes.bool,
    vintageTwo: PropTypes.bool,
    right: PropTypes.bool,
    left: PropTypes.bool,
    className: PropTypes.string,
}

export default VintageBox
